import React, { useContext } from "react";
import { themeContext } from "../../Context";
import "./Experience.css";

const Experience = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="experience" id="experience">
      <div className="achievement">
        <div className="circle circle-lg" style={{ color: darkMode ? "var(--orange)" : "" }}>
          +800
        </div>
        <span style={{ color: darkMode ? "white" : "" }}>عميل</span>
        <span>في السعودية واليمن والدول العربية</span>
      </div>
      <div className="achievement">
        <div className="circle" style={{ color: darkMode ? "var(--orange)" : "" }}>8+</div>
        <span style={{ color: darkMode ? "white" : "" }}>سنوات</span>
        <span>الخبرة</span>
      </div>
      <div className="achievement">
        <div className="circle" style={{ color: darkMode ? "var(--orange)" : "" }}>10+</div>
        <span style={{ color: darkMode ? "white" : "" }}>محترف</span>
        <span>أعضاء الفريق</span>
      </div>
    </div>
  );
};

export default Experience;
